export const EDIT_MODE_STREAM_ID = "edit-mode";

export const APPLY_UNIQUE_TOKEN = "<|!@#IS_APPLY!@#|>";
